import React from 'react';
import { Fit, ItemText, fs } from '../parts/fields';
import { Head, Logo } from '../parts/chrome';
import { items, useSlide } from '../parts/context';

// #region StepsLayout
/** How it works: two to five numbered steps on a line. */
export const StepsLayout: React.FunctionComponent = (): React.ReactElement => {
    const { slide } = useSlide();
    const list = items(slide.fields.items);
    const n = Math.max(1, list.length);
    const dense = n >= 5;
    return (
        <>
            <div className="wd-pad">
                <Head />
                <Fit style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: `repeat(${n}, minmax(0, 1fr))`, columnGap: dense ? 48 : 64 }}>
                        {list.map((_, i) => (
                            <div key={i} style={{ position: 'relative', minWidth: 0 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 24, marginBottom: 40 }}>
                                    <span className="wd-num" style={{ flex: 'none', width: 88, height: 88, borderRadius: '50%', display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                        background: 'var(--wd-accent)', color: '#fff', fontSize: 38 }}>{i + 1}</span>
                                    {i < list.length - 1 ? <span aria-hidden="true" style={{ flex: 1, height: 3, borderRadius: 2, background: 'linear-gradient(90deg, var(--wd-accent), color-mix(in srgb, var(--wd-accent) 12%, transparent))' }} /> : null}
                                </div>
                                <ItemText index={i} part="title" className="wd-h" style={{ fontSize: fs(dense ? 32 : 38), lineHeight: 1.15, paddingRight: 16 }} placeholder="Step" max={50} />
                                <ItemText index={i} part="body" className="wd-lead wd-clamp" style={{ fontSize: fs(dense ? 23 : 26), marginTop: 16, color: 'var(--wd-muted)', paddingRight: 16 }} placeholder="What happens" max={200} />
                            </div>
                        ))}
                    </div>
                </Fit>
            </div>
            <Logo />
        </>
    );
};
